import { brand, cardBase, text } from '@/styles/shared';

export const instructionCardStyles = {
  container: {
    ...cardBase,
    padding: '25px',
    marginBottom: '20px',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    transition: 'padding 200ms ease, box-shadow 200ms ease',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
    cursor: 'pointer',
    transition: 'margin-bottom 200ms ease',
  },
  iconBox: {
    width: '24px',
    height: '24px',
    marginRight: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#000000',
    fontFamily: 'Montserrat',
    lineHeight: 1.219,
  },
  contentTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#000000',
    fontFamily: 'Montserrat',
    lineHeight: 1.219,
    marginBottom: '12px',
  },
  instructionsList: {
    marginBottom: '24px',
  },
  instructionItem: {
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  greenCheckIcon: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: brand.greenPrimary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  purpleCheckIcon: {
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    backgroundColor: brand.purpleAccent,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  instructionText: {
    ...text.body14Muted,
    marginLeft: '14px',
  },
  description: {
    ...text.body14Muted,
    marginBottom: '24px',
    textAlign: 'center',
  },
  chevron: (open: boolean) => ({
    marginLeft: 'auto',
    fontSize: '18px',
    lineHeight: 1,
    color: '#000000',
    userSelect: 'none',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 200ms ease',
  }),
};
